module.exports = __webpack_public_path__ + "static/media/EC.42fcf1ae.png";